/**
 * Initiate the project filters
 */
export const initProjectFilters = function() {
  $(document).on('click', '[data-filter]', (e) => {
    const target = $(e.target);
    const filter = target.attr('data-filter');
    const parent = $(target.parents('[data-filters]')[0]);
    const filters = parent.attr('data-filters');
    const slider = $(`#${filters}`)[0].swiper;

    // switch active class
    parent.children().removeClass('category-list__item--active');
    target.parent().addClass('category-list__item--active');

    // filter the slides
    for (let i = 0; i < slider.slides.length; i++) {
      const slide = slider.slides[i];
      const cat = $(slide).attr('data-filter-cat').split(',');
      if (cat.indexOf(filter) === -1) {
        $(slide).hide();
      } else {
        $(slide).show();
        slider.lazy.loadInSlide(i);
      }
    }

    slider.update();
  });
};